<template>
  <v-dialog v-model="showModal" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline secondary white--text">
        Link Account to User
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="isFormValid">
          <v-layout row wrap>
            <v-flex xs12>
              <v-autocomplete
                v-model="selectedAccount"
                :items="accounts"
                :loading="isSearching"
                :search-input.sync="searchValue"
                item-text="name"
                item-value="id"
                label="Search Account"
                placeholder="Type to search accounts..."
                prepend-icon="fa-search"
                return-object
                clearable
                box
                :rules="[rules.required]"
              >
                <template v-slot:item="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex xs12>
              <v-checkbox
                v-model="linkTerminals"
                label="Link all terminals from this account"
                color="primary"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12>
              <v-checkbox
                v-model="enableReporting"
                label="Enable standard reporting for this account"
                color="primary"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="!isFormValid || isProcessing"
          :loading="isProcessing"
          @click="linkAccount"
        >
          Link Account
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Bus from '@/bus'
import ApiMixin from '@/mixins/api'

export default {
  name: 'LinkAccountModal',
  mixins: [ApiMixin],

  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [Number, String],
      required: true
    },
    existingAccountIds: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      isFormValid: false,
      isSearching: false,
      isProcessing: false,
      searchValue: '',
      selectedAccount: null,
      accounts: [],
      linkTerminals: true,
      enableReporting: false,
      rules: {
        required: value => !!value || 'Account is required'
      }
    }
  },

  computed: {
    showModal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    searchValue (val) {
      this.searchAccounts(val || '')
    },
    value (val) {
      if (val) {
        this.reset()
        // Load accounts immediately when modal opens
        this.searchAccounts('')
      }
    }
  },

  methods: {
    reset () {
      this.selectedAccount = null
      this.searchValue = ''
      this.accounts = []
      this.linkTerminals = true
      this.enableReporting = false
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },

    async searchAccounts (value) {
      this.isSearching = true
      try {
        let result = await this.api({
          method: 'post',
          url: '/users/accounts/autocomplete',
          data: {
            value: value,
            ignoreIds: this.existingAccountIds
          }
        })
        this.accounts = result.data.accounts
      } catch (error) {
        console.error('Error searching accounts:', error)
      } finally {
        this.isSearching = false
      }
    },

    async linkAccount () {
      if (!this.selectedAccount) {
        return
      }

      this.isProcessing = true
      try {
        await this.api({
          method: 'post',
          url: `/users/${this.userId}/accounts`,
          data: {
            account_id: this.selectedAccount.id,
            link_terminals: this.linkTerminals,
            enable_reporting: this.enableReporting
          }
        })

        Bus.$emit('openModal', {
          status: 'success',
          message: `Account "${this.selectedAccount.name}" linked successfully`
        })

        this.$emit('linked')
        this.close()
      } catch (error) {
        Bus.$emit('openModal', {
          status: 'error',
          message: (error.response && error.response.data && error.response.data.error) || 'Error linking account'
        })
      } finally {
        this.isProcessing = false
      }
    },

    close () {
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/user/LinkAccountModal.vue